import { render, staticRenderFns } from "./TutorialBtn.vue?vue&type=template&id=46cebc0f&scoped=true&"
import script from "./TutorialBtn.vue?vue&type=script&lang=ts&"
export * from "./TutorialBtn.vue?vue&type=script&lang=ts&"
import style0 from "./TutorialBtn.vue?vue&type=style&index=0&id=46cebc0f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cebc0f",
  null
  
)

export default component.exports